import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-lock\">\n    <g fill=\"none\" fill-rule=\"evenodd\" opacity=\".6\" transform=\"translate(4 3)\">\n        <rect width=\"15\" height=\"9\" x=\".5\" y=\"8.5\" stroke=\"#000\" rx=\"2\" />\n        <path fill=\"#000\" d=\"M7 11H9V15H7z\" />\n        <path stroke=\"#000\" d=\"M3 7V4.846C3 2.17 5.239 0 8 0s5 2.17 5 4.846\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol